import React, {PropsWithChildren, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DropdownMenuCompact from '../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import useCreateNewSlide from '../../service/hooks/useCreateNewSlide';
import {SLIDE_TEMPLATE_OPTIONS} from '../../service/template/slideTemplateOptions';
import ImportSlideModal from '../../ui/components/common/modal/importSlideModal/ImportSlideModal';

interface AddNewSlideWrapperProps {
    fixed?: 'top' | 'bottom' | 'left' | 'right';
    toEnd?: boolean;
    openOnMouseEnter?: boolean;
    closeOnMouseExit?: boolean;
    closeOnMouseExitDelayMs?: number;
}

function AddNewSlideWrapper(props: PropsWithChildren<AddNewSlideWrapperProps>): JSX.Element {
    const {t} = useTranslation();
    const {createNewSlide} = useCreateNewSlide();

    const {fixed, toEnd = false, openOnMouseEnter, closeOnMouseExit, closeOnMouseExitDelayMs, children} = props;

    const [openImportModal, setImportModalOpen] = useState(false);

    return (
        <>
            <DropdownMenuCompact
                fixed={fixed}
                openOnMouseEnter={openOnMouseEnter}
                closeOnMouseExit={closeOnMouseExit}
                closeOnMouseExitDelayMs={closeOnMouseExitDelayMs}
                items={[
                    SLIDE_TEMPLATE_OPTIONS.map((option) => ({
                        label: t(option.labelKey),
                        icon: option.icon,
                        onClick: () => createNewSlide(option.template, toEnd),
                        dataCy: option.template.toString(),
                    })),
                    [
                        {
                            label: t('presEditPage.importSlide'),
                            icon: 'solar:upload-minimalistic-linear',
                            onClick: () => setImportModalOpen(true),
                            dataCy: 'import-slide',
                        },
                    ],
                ]}
            >
                {children}
            </DropdownMenuCompact>

            <ImportSlideModal
                isOpen={openImportModal}
                onCancel={() => {
                    setImportModalOpen(false);
                }}
                onConfirm={() => {
                    setImportModalOpen(false);
                }}
            />
        </>
    );
}

export default AddNewSlideWrapper;
